export const mapDataForBackend = (contactInfo) => ({
  description: `${contactInfo.description} | Kontakt via: ${contactInfo.telNumber}`,
});

export const mapDataForBackendLKF = (contactInfo) => ({
  /* eslint-disable max-len */
  description: `${contactInfo.description}\n\n\nKontakt via: ${contactInfo.telType === 'other' ? `Annat: ${contactInfo.telNumber}` : contactInfo.telNumber}`,
});
